import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'
import { sizes } from '../style-utils'

export const MediaWrapper = styled.div`
    position: relative;
    max-width: ${sizes.tablet}px;
    margin: 0 auto;
`

export const ClassifierActionsBar = styled.div`
    position: absolute;
    bottom: 0;
    height: 75px;
    width: 100%;
    background-color: rgba(52,58,64, 0.7);
`

export const TrashIcon = styled(FontAwesome)`
    color: ${props => props.color};
    position: absolute;
    bottom: 0;
    line-height: 75px;
    left: 20px;
`

export const GalleryUploadImageIcon = styled(FontAwesome)`
    color: #fff;
    position: absolute;
    bottom: 0;
    line-height: 75px;
    right: 20px;
`

export const UploadImageIconWrapper = styled.div`
    width: 160px;
    height: 50px;
    margin: 0 auto;
    top: 12px;
    position: relative;
    text-align: center;
`

export const UploadImageIcon = styled.img`
    width: 50px;
    height: 50px;
`

export const TakeScreenshotButtonWrapper = styled.div`
    border-radius: 50%;
    background-color: #fff;
    width: 50px;
    height: 50px;
    margin: 0 auto;
    top: 12px;
    position: relative;
    
    &:active > div {
        border: 4px solid #000;
    }
`

export const TakeScreenshotButton = styled.div`
    border-radius: 50%;
    width: 44px;
    height: 44px;
    margin: 0 auto;
    border: 2px solid #000;
    top: 3px;
    position: relative;
    
    &:active {
        border: 4px solid #000;
    }
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Classifier/Camera.js